import type { Infer } from "superstruct";
import { literal, object } from "superstruct";
import type { InjectionToken } from "tsyringe";

import { REWARDS_WIDGETS_PLACEHOLDERS } from "./constants/constants";

export const RewardsApplicationConfigSchema = object({
    drawerWidgetPlaceholder: literal(
        REWARDS_WIDGETS_PLACEHOLDERS.drawerWidgetPlaceholder
    ),
    popUpWidgetWrapperPlaceholder: literal(
        REWARDS_WIDGETS_PLACEHOLDERS.popUpWidgetWrapperPlaceholder
    ),
    popUpRootWidgetPlaceholder: literal(
        REWARDS_WIDGETS_PLACEHOLDERS.popUpRootWidgetPlaceholder
    ),
    verifyAccountModalWidgetPlaceholder: literal(
        REWARDS_WIDGETS_PLACEHOLDERS.verifyAccountModalWidgetPlaceholder
    ),
    joinNowModalWidgetPlaceholder: literal(
        REWARDS_WIDGETS_PLACEHOLDERS.joinNowModalWidgetPlaceholder
    ),
    waysToEarnPageWidgetPlaceholder: literal(
        REWARDS_WIDGETS_PLACEHOLDERS.waysToEarnPageWidgetPlaceholder
    ),
    waysToEarnPageWidgetModalPlaceholder: literal(
        REWARDS_WIDGETS_PLACEHOLDERS.waysToEarnPageWidgetModalPlaceholder
    ),
    waysToSpendPageWidgetPlaceholder: literal(
        REWARDS_WIDGETS_PLACEHOLDERS.waysToSpendPageWidgetPlaceholder
    ),
    waysToSpendPageWidgetModalPlaceholder: literal(
        REWARDS_WIDGETS_PLACEHOLDERS.waysToSpendPageWidgetModalPlaceholder
    ),
    availableRewardsPageWidgetPlaceholder: literal(
        REWARDS_WIDGETS_PLACEHOLDERS.availableRewardsPageWidgetPlaceholder
    ),
    availableRewardsPageWidgetModalPlaceholder: literal(
        REWARDS_WIDGETS_PLACEHOLDERS.availableRewardsPageWidgetModalPlaceholder
    ),
    vipTiersPageWidgetPlaceholder: literal(
        REWARDS_WIDGETS_PLACEHOLDERS.vipTiersPageWidgetPlaceholder
    ),
    vipTiersCardWidgetPlaceholder: literal(
        REWARDS_WIDGETS_PLACEHOLDERS.vipTiersCardWidgetPlaceholder
    ),
    vipTiersSingleProgressWidgetPlaceholder: literal(
        REWARDS_WIDGETS_PLACEHOLDERS.vipTiersSingleProgressWidgetPlaceholder
    ),
    vipTiersMultiProgressWidgetPlaceholder: literal(
        REWARDS_WIDGETS_PLACEHOLDERS.vipTiersMultiProgressWidgetPlaceholder
    ),
    referralProgramPageWidgetPlaceholder: literal(
        REWARDS_WIDGETS_PLACEHOLDERS.referralProgramPageWidgetPlaceholder
    ),
    referralsPageWidgetPlaceholder: literal(
        REWARDS_WIDGETS_PLACEHOLDERS.referralsPageWidgetPlaceholder
    ),
    historyPageWidgetPlaceholder: literal(
        REWARDS_WIDGETS_PLACEHOLDERS.historyPageWidgetPlaceholder
    ),
    earnPointsProductPageWidgetPlaceholder: literal(
        REWARDS_WIDGETS_PLACEHOLDERS.earnPointsProductPageWidgetPlaceholder
    ),
    earnPointsCartWidgetPlaceholder: literal(
        REWARDS_WIDGETS_PLACEHOLDERS.earnPointsCartWidgetPlaceholder
    ),
    loyaltyInfoPageWidgetPlaceholder: literal(
        REWARDS_WIDGETS_PLACEHOLDERS.loyaltyInfoPageWidgetPlaceholder
    ),
    emptyStatePageWidgetPlaceholder: literal(
        REWARDS_WIDGETS_PLACEHOLDERS.emptyStatePageWidgetPlaceholder
    ),
    qrCodeModalWidgetPlaceholder: literal(
        REWARDS_WIDGETS_PLACEHOLDERS.qrCodeModalWidgetPlaceholder
    ),
    customerPointsBalanceInlineWidgetPlaceholder: literal(
        REWARDS_WIDGETS_PLACEHOLDERS.customerPointsBalanceInlineWidgetPlaceholder
    ),
    faqPageWidgetPlaceholder: literal(
        REWARDS_WIDGETS_PLACEHOLDERS.faqPageWidgetPlaceholder
    ),
});

export type RewardsApplicationConfigInterface = Infer<
    typeof RewardsApplicationConfigSchema
>;

export const RewardsApplicationConfigToken = Symbol(
    "RewardsApplicationConfigToken"
) as InjectionToken<RewardsApplicationConfigInterface>;
